export enum WandaPayment {
  CreditCard = 1,
  CyberSource = 1,
}

type Customer = {
  firstName: string;
  middleName?: string;
  lastName: string;
  title?: string;
  email: string;
  phoneNumber?: string;
};

type BillTo = {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  country?: string;
  zip: string;
};

type Card = {
  number: string;
  expirationYear: number;
  expirationMonth: number;
  securityCode: string;
};

export type PaymentInstrumentValidationData = {
  personId?: number;
  instrumentType: number;
  gatewayType: number;
  customer: Customer;
  billTo: BillTo;
  card: Card;
};

export type SavePaymentInstrumentPayload = {
  personId?: number;
  isDefault?: boolean;
  customer: Customer;
  billTo: BillTo;
  card: Card;
};

export type DefaultPaymentInstrumentPayload = {
  paymentInstrumentType: number;
  paymentGatewayType: number;
  personId?: number;
};

export type CreditCardDetails = {
  customerPersonId: number;
  paymentInstrumentId: number;
  isDefault: boolean;
  expiresOn: string;
  createdOn: string;
  editedOn: string | null;
  gatewayTypeName: string;
  instrumentTypeName: string;
  gatewayType: number;
  instrumentType: number;
  name: string;
  last4: string;
  kind: string;
};

export const defaultCreditCardDetails = {
  customerPersonId: 0,
  paymentInstrumentId: 0,
  isDefault: false,
  expiresOn: "",
  createdOn: "",
  editedOn: "",
  gatewayTypeName: "",
  instrumentTypeName: "",
  gatewayType: 0,
  instrumentType: 0,
  name: "",
  last4: "",
  kind: "",
};

export interface SaveCreditCardResponse {
  paymentInstrumentId: number;
  gatewayTypeName: string;
  instrumentTypeName: string;
  gatewayType: number;
  instrumentType: number;
  name: string;
  last4: string;
  kind: string;
}
